<template>
    <div class="container">
        <!-- Team members structure start -->
        <div class="team-members row">
            <!-- effect-1 html -->
                    <div v-for="(item,index) in partArray" @click="onSelect(item.childurl)">
                        <router-link class="fb-touch" :to="{path:item.childurl}">
                    <div class="single-member effect-1">
                        <div class="member-image">
                            <img v-bind:src=item.nodedesc alt="Member">
                        </div>
                        <div class="member-info">
                            <h3 class="index-itemh3">{{item.name}}</h3>
                            <div class="social-touch">
                                <!--
                                <a class="tweet-touch" href="#"></a>
                                <a class="linkedin-touch" href="#"></a>-->
                            </div>
                        </div>
                    </div>
                        </router-link>
                    </div>
            <!-- effect-1 html end -->

        </div>
        <!-- Team members structure start -->
    </div>
</template>
<script>
    export default {
        created(){
            //调用查询函数
            this.getData();
        },
        data(){

            return{
                partArray:[]
            }
        },
        methods: {
            getData(){
                //数据请求
                this.$http.get(this.requetHost+'/sys/user/findFirstMenu',{params:{userName:this.getcookie('username')}})
                    .then(response => {
                            if (response.status === 200) {
                                //debugger;
                                this.partArray = response.body.firstmenu;

                            }else{
                                this.$message({
                                    showClose: true,
                                    message: '一级菜单加载不正确',
                                    type: 'error'
                                });
                            }
                            this.loading = false;
                        },function(response){
                            this.$message({
                                showClose: true,
                                message: '网络异常',
                                type: 'error'

                            });
                        }
                    )
            },
//            ,
//            findPermissions(resourceId{
//                this.$http.get(this.requetHost + '/sys/user/findPermissions', {
//                    params: {
//                        "userName": this.getcookie('username'),
//                        "pid":resourceId
//                    }
//                }).then(response => {
//                    if (response.status === 200) {
//                    //this.  =response.body.tree[0].children;
//                    this.data2 = response.body.tree;
//                    //this.child = this.data2.children;
//                } else {
//                    this.$message({
//                        showClose: true,
//                        message: '树资源加载不正确',
//                        type: 'error'
//                    });
//                }
//                this.loading = false;
//
//            },function (response) {
//                    this.$message({
//                        showClose: true,
//                        message: '网络异常',
//                        type: 'error'
//
//                    });
//                })
//            }

            onSelect(val) {
                this.savecookie("menu_url",val,24*60*60);
            }
        },
        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'getData'
        }

    }
</script>
<style>
    @import url('../assets/css/style.css');
    .container{
        position: absolute;
        width: 100%;
        padding-top: 75px;
       // background-color:palegreen;
        /*opacity:0.9;
        filter:alpha(opacity=90);*/
    }

    .single-member{
        margin-bottom: 70px;
    }
    .index-itemh3{
        line-height: 80px;
        font-size: 20px;
        font-weight: bold;

    }
</style>


// WEBPACK FOOTER //
// Index.vue?31e756ae